import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import api from '../../../services/api';

const Step9Emergency = () => {
    const { mockUser, refreshUser } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        countryCode: '+91',
        mobile: '',
        email: '',
        captcha: ''
    });

    // Load Data
    useEffect(() => {
        const init = async () => {
            try {
                const res = await api.get(`/mock-cuet/application-data?mockAppId=${mockUser.id}`);
                if (res.data.success) {
                    const db = res.data.data;
                    setFormData(prev => ({
                        ...prev,
                        countryCode: db.guardian_country_code || '+91',
                        mobile: db.guardian_mobile || '',
                        email: db.guardian_email || ''
                    }));
                }
            } catch (err) { console.error(err); }
        };
        init();
    }, [mockUser]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await api.post('/mock-cuet/save-step', {
                mockAppId: mockUser.id,
                stepNumber: 9,
                stepData: formData,
                nextStepNumber: 10
            });

            if (res.data.success) {
                refreshUser(10);
                navigate('/services/counselling/dashboard/photo-capture');
            }
        } catch (err) {
            alert("Error saving data.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="ctl00_ContentPlaceHolder1_pnlApplicationForm">
            <div className="appstatus" style={{ paddingTop: '0px', marginTop: '0px' }}>
                <div id="ctl00_ContentPlaceHolder1_Pnlmasg">
                    
                    <h4>
                        माता-पिता / अभिभावक का आपातकालीन संपर्क विवरण (Emergency Contact Details of Parent's / Guardian's)
                    </h4>
                    <br /><br />
                    
                    <div className="form-horizontal formLabel">
                        
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                देश कोड (Country Code) :
                            </label>
                            <div className="col-sm-4">
                                <select 
                                    name="countryCode" 
                                    className="form-control" 
                                    value={formData.countryCode} 
                                    onChange={handleChange}
                                >
                                    <option value="+91">India (+91)</option>
                                    <option value="+1">USA (+1)</option>
                                    <option value="+44">UK (+44)</option>
                                    <option value="+971">UAE (+971)</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                मोबाइल नंबर (Mobile Number) :
                            </label>
                            <div className="col-sm-4">
                                <input 
                                    name="mobile" 
                                    type="text" 
                                    maxLength="10" 
                                    className="form-control" 
                                    value={formData.mobile} 
                                    onChange={handleChange} 
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                ईमेल पता (Email Address) :
                            </label>
                            <div className="col-sm-4">
                                <input 
                                    name="email" 
                                    type="email" 
                                    className="form-control" 
                                    value={formData.email} 
                                    onChange={handleChange} 
                                    required
                                />
                            </div>
                        </div>

                        <br/>

                        {/* CAPTCHA */}
                        <h4>CAPTCHA</h4>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Enter CAPTCHA as shown below <small className="text-primary">(case sensitive) </small>
                            </label>
                            <div className="col-sm-4">
                                <input 
                                    name="captcha" 
                                    type="text" 
                                    className="form-control" 
                                    value={formData.captcha} 
                                    onChange={handleChange} 
                                    required
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">CAPTCHA</label>
                            <div className="col-sm-4">
                                 <div style={{display:'inline-block', verticalAlign:'middle'}}>
                                    <img src="/assets/cuet-mock/images/DisplayCaptchaImg.jpg" alt="Captcha" style={{height:'34px', borderWidth:'0px'}} />
                                 </div>
                                 <div style={{display:'inline-block', verticalAlign:'middle', marginLeft:'10px'}}>
                                    <img src="/assets/cuet-mock/images/Refresh.png" alt="Refresh" style={{height:'30px', width:'30px', cursor:'pointer'}} />
                                 </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="form-group">
                                <div className="col-sm-12 text-center" style={{marginTop:'20px'}}>
                                    <button type="button" className="btn btn-warning" onClick={() => navigate('/services/counselling/dashboard/additional-details')} style={{marginRight:'10px'}}>
                                        Back
                                    </button>
                                    <button type="submit" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
                                        {loading ? 'Saving...' : 'Save & Next'}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step9Emergency;